<template>
  <v-img
    :aspect-ratio="649 / 529"
    :src="hdLogo"
    :style="{ opacity }"
    :width="width"
    alt="HD logo"
  />
</template>

<script setup>
import hdLogo from '#root/assets/logos/hd.svg'

defineProps({
  opacity: {
    default: 1,
    type: Number
  },
  width: {
    default: 100,
    type: Number
  }
})
</script>
